import { render, staticRenderFns } from "./regles.vue?vue&type=template&id=55968c18&scoped=true"
import script from "./regles.vue?vue&type=script&lang=ts"
export * from "./regles.vue?vue&type=script&lang=ts"
import style0 from "./regles.vue?vue&type=style&index=0&id=55968c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55968c18",
  null
  
)

export default component.exports